import { useRef } from 'react';
import Tag from '@/components/Tag';
import { getRowId } from '../utils';

const SelectCell = ({ row, column, value, onOpenSelect }) => {
  const cellRef = useRef(null);
  const isEditable = column.editable !== false;
  const cellClass = `grid-table-select-cell-${column.key}-${getRowId(row, column.rowKey || 'id')}`;
  const options = column.options || [];
  const currentOption = options.find((opt) => opt.value === value) || null;

  const labelFromOption = currentOption?.label ?? value ?? '-';
  const label = column.getOptionLabel ? column.getOptionLabel(currentOption, row, column) : labelFromOption;
  const icon = column.getOptionIcon ? column.getOptionIcon(currentOption, row, column) : currentOption?.icon;
  const style = column.getValueStyle ? column.getValueStyle({ option: currentOption, row, column }) : undefined;

  const handleOpen = () => {
    if (!isEditable || (!onOpenSelect && !column.onOpen)) {
      return;
    }
    if (onOpenSelect) {
      onOpenSelect({
        row,
        column,
        cellClass
      });
    }
    if (column.onOpen) {
      column.onOpen({ row, column, cellClass });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleOpen();
      setTimeout(() => cellRef.current?.focus(), 0);
    }
  };

  if (column.variant === 'tag') {
    return (
      <div
        className={`comp-grid-table-cell status-cell editable ${cellClass} ${column.cellClassName || ''}`}
        data-title={label}
        onClick={(e) => {
          e.stopPropagation();
          handleOpen();
        }}
        ref={cellRef}
        tabIndex={isEditable ? 0 : -1}
        onKeyDown={handleKeyDown}>
        <Tag className="pill" size="md" icon={icon} iconVariant="" onClick={handleOpen} style={{ cursor: 'pointer', ...(style || {}) }}>
          {label}
        </Tag>
      </div>
    );
  }

  return (
    <div
      className={`comp-grid-table-cell select-cell ${isEditable ? 'editable' : 'read-only'} ${cellClass} ${column.cellClassName || ''}`}
      data-title={label}
      onClick={(e) => {
        e.stopPropagation();
        handleOpen();
      }}
      ref={cellRef}
      tabIndex={isEditable ? 0 : -1}
      onKeyDown={handleKeyDown}>
      <div className="select-value">
        <span className="value-display">{label}</span>
      </div>
    </div>
  );
};

export default SelectCell;
